export const CONTRACT_ADDRESS = "FtSRgyCEhKTc1PPgEAXvuHN3NyiP6LS9uyB28KCN3CAP"
export const API_BASE_URL = "https://api.captcha.social"
export const DOCS_URL = "https://docs.captcha.social"
export const APP_STORE_URL = "https://apps.apple.com/app/id6759180163"
export const TWITTER_URL = "https://x.com/captchaapp"
export const MAX_API_KEYS = 2
